import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileMenu.css';
import logo from '../../img/logos2.png';

const MobileMenu = ({ isOpen, onClose, onNavClick }) => {
  const location = useLocation();

  const handleNavClick = (sectionId) => {
    if (location.pathname === '/') {
      // Если мы уже на главной, используем плавную прокрутку
      onNavClick(sectionId);
      onClose();
    } else {
      // Если на другой странице, переходим на главную с якорем через React Router
      // Закрываем меню
      onClose();
    }
  };

  const handlePrivacyClick = () => {
    onClose();
  };

  return (
    <>
      {/* Оверлей */}
      <div 
        className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`} 
        onClick={onClose}
      />
      
      {/* Меню */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <nav className="mobile-nav">
            {/* Для главной страницы используем плавную прокрутку, для других - Link с якорем */}
            {location.pathname === '/' ? (
              <>
                {/* <a href="#start" onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('start');
                }}>НАЧАЛО</a> */}
                
                <a href="#okompanii" onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('okompanii');
                }}>О нас</a>
                
                <a href="#LayoutGrid6" onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('LayoutGrid6');
                }}>Миграция</a>
                
                <a href="#LayoutGrid1" onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('LayoutGrid1');
                }}>Вопросы</a>
                
                <a href="#contacts" onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('contacts');
                }}>Контакты</a>
              </>
            ) : (
              <>
                <Link to="/#okompanii" onClick={onClose}>О нас</Link>
                <Link to="/#LayoutGrid6" onClick={onClose}>Миграция</Link>
                <Link to="/#LayoutGrid1" onClick={onClose}>Вопросы</Link>
                <Link to="/#contacts" onClick={onClose}>Контакты</Link>
              </>
            )}
            
            <Link to="/privacy-policy" onClick={handlePrivacyClick}>
              Политика конфиденциальности
            </Link>
          </nav>
          <div className="mobile-menu-logo">
            <img src={logo} alt="Гостиница Белая" />
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;